import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { RoleGuard } from "@/components/shared/guards/role-guard";
import { PlatformAdminPage } from "@/features/platform-admin";

const platformAdminSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  limit: z.coerce.number().int().min(1).max(100).catch(20),
});

/** F-25: Platform Admin, reachable only by `platform_admin` — never granted by any tenant-scoped role, never self-service. */
function PlatformAdminRoute() {
  return (
    <RoleGuard allowedRoles={["platform_admin"]}>
      <PlatformAdminPage />
    </RoleGuard>
  );
}

export const Route = createFileRoute("/platform-admin/")({
  validateSearch: platformAdminSearchSchema,
  component: PlatformAdminRoute,
});
